export var ListingSort;
(function (ListingSort) {
    ListingSort["DEFAULT"] = "DEFAULT";
    ListingSort["PRICE_ASC"] = "PRICE_ASC";
    ListingSort["PRICE_DESC"] = "PRICE_DESC";
    ListingSort["MOST_RECENT"] = "MOST_RECENT";
})(ListingSort || (ListingSort = {}));
export const LISTING_SORT_LABELS = {
    [ListingSort.DEFAULT]: 'Default',
    [ListingSort.PRICE_ASC]: 'Lowest Price',
    [ListingSort.PRICE_DESC]: 'Highest Price',
    [ListingSort.MOST_RECENT]: 'Most Recent',
};
const comparators = {
    [ListingSort.PRICE_ASC]: (a, b) => a.basePriceCents - b.basePriceCents,
    [ListingSort.PRICE_DESC]: (a, b) => b.basePriceCents - a.basePriceCents,
    [ListingSort.MOST_RECENT]: (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt),
};
export const sortListings = (listings, sort) => sort === ListingSort.DEFAULT
    ? listings
    : [...listings].sort(comparators[sort]);
